import { HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { of } from 'rxjs';
import { tap } from 'rxjs/operators';
import { HttpCacheService } from '../services/http-cache.service';

export const externalIdCacheInterceptor: HttpInterceptorFn = (req, next) => {
  const cacheService = inject(HttpCacheService);

  if (req.method === 'GET' && req.url.endsWith('/user/me/externalId')) {
    const cached = cacheService.get(req.url);

    if (cached !== undefined) {
      return of(cached);
    }

    return next(req).pipe(
      tap((response) => {
        if (response instanceof HttpResponse && response.status === 200) {
          cacheService.set(req.url, response);
        }
      })
    );
  }
  
  return next(req);
};